import React from 'react';
import PropTypes from 'prop-types';

export default function WildfireIcon({ color = '#ffffff', width = 20, height = 20 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={width} height={height} fill={color}>
      <path d="M256 490.7c88.4 0 160-71.6 160-160c0-18.5-4.9-36.2-10.7-52.7c-35.6 35.1-62.6 52.7-81.1 52.7C409.5 181.3 362.7 117.3 234.7 32c10.7 106.7-59.6 155.2-88.3 182.1C115.4 243.3 96 284.7 96 330.7c0 88.4 71.6 160 160 160zm15.1-379c69.2 58.7 69.5 104.3 16.1 197.8c-16.2 28.4 4.3 63.8 37.1 63.8c14.7 0 29.5-4.3 45.2-12.7C356.2 410.9 310.4 448 256 448c-64.8 0-117.3-52.5-117.3-117.3c0-32.8 13.5-63.4 37-85.5c2.7-2.5 16.3-14.6 16.9-15.1c9-8.1 16.5-15.3 23.9-23.2c26.2-28.1 45.1-59.3 54.8-95.2z" />
    </svg>
  );
}

WildfireIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};
